// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"v8-z","inlineTitle":"w8-z","sponsoredAdsWrapper":"x8-z","marketplaceRecosWrapper":"y8-z","brandShopTheLookWrapper":"z8-z"};